export default __webpack_public_path__ + "static/media/icn-user-add.9f633237.svg";